// extracted by mini-css-extract-plugin
module.exports = {"root":"FormPwdLogin_root_2ye09"};